<template>
    <div class="a-video">
        <div class="a-video__title">{{title}}</div>
        <div class="a-video__controls pl-3" v-if="canEdit" @click="editMode=!editMode">Изменить</div>
        <div v-if="canEdit && editMode===true" ref="uploadField" class="flex mb-3">
            <a-input type="file" v-model="uploadedFiles['file']" label=" " placeholder="Заменить файл" class="mr-3"/>
            <a-btn label="Удалить" fill="flat" @click="deleteVideo" />
        </div>
        <div class="a-video__inner">
            <fancybox :src="src" :name="name">
                <div class="a-video__body">
                    <img class="a-video__cover" :src="modCover.src" alt="" v-if="!modCover.video&&modCover.src">
                    <video v-else-if="modCover.src"   mute="true" playsinline="true" :src="modCover.src+'#t=10,20'"  class="a-video__cover"></video>
                    <button type="button" class="a-video__play">
                        <svg width="54" height="54" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8 0C3.58178 0 0 3.58172 0 8C0 12.4183 3.58178 16 8 16C12.4182 16 16 12.4183 16 8C16 3.58172 12.4182 0 8 0ZM10.765 8.42406L6.765 10.9241C6.68406 10.9746 6.59203 11 6.5 11C6.41663 11 6.33313 10.9792 6.25756 10.9373C6.09863 10.8491 6 10.6819 6 10.5V5.5C6 5.31812 6.09863 5.15088 6.25756 5.06275C6.4165 4.97412 6.61084 4.9795 6.765 5.07594L10.765 7.57594C10.9111 7.6675 11 7.82766 11 8C11 8.17234 10.9111 8.33253 10.765 8.42406Z"/>
                        </svg>
                    </button>
                </div>
            </fancybox>
        </div>
    </div>
</template>

<script>
import {ref, watch} from 'vue';
import {AInput, ABtn} from "~/components/ui";
import Fancybox from '../Fancybox/Fancybox.vue'

export default {
    name: 'AVideo',
    components: {
        Fancybox,
        AInput,
        ABtn
    },
    props: {
        title: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: '',
        },
        src: {
            type: String,
            default: '',
        },
        cover: {
            type: String,
            default: '',
        },
        canEdit: Boolean
    },
    emits: ['update:modelValue'],
    setup: (props, ctx) => {
        const editMode = ref(false);
        const uploadedFiles = ref({});
        let imgRash = [
        "png",
        "jpg",
        "webp",
        "gif",
        "bpm",
        "jpeg"
      ];
        let rash = props.cover.split('.').pop();
        const modCover = ref({src:props.cover,video:imgRash.indexOf(rash)<0});


        watch(uploadedFiles.value, val => {
          ctx.emit('update:modelValue', val.file[0])
        })
        const deleteVideo = () => {
            console.log('deleteVideo')
        }

        return {editMode,uploadedFiles, deleteVideo,modCover}
    },
}
</script>

<style lang="scss" scoped>
    .a-video {
        &__title{
            display: inline-block;
            width: max-content;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            margin-bottom: 12px;
        }
        &__controls {
            display: inline-block;
            width: max-content;
            font-weight: 600;
            font-size: 14px;
            line-height: 19px;
            color: var(--c-primary-200);
            cursor: pointer;
        }
        &__body {
            position: relative;
            border-radius: var(--br-1);
            overflow: hidden;
            cursor: pointer;
        }
        &__cover {
            object-fit: cover;
          width: 100%;
        }
        &__play {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            width: 54px;
            height: 54px;
            cursor: pointer;
            background: transparent;
            border: none;
            color: #fff;

            svg {
                fill: currentColor
            }
        }

        ::v-deep .a-field-file{
            margin: 0;
        }
    }
</style>